import { routerManager } from './app-routes';
import { RouteKey } from './RouterManager/types';

const hasRoute = (pathname: string, routeName: string) => {
  const currentPath = routerManager.getUrl(routeName as RouteKey);
  // Nos aseguramos que termine con / para el hecho de que emisoras y emisoras-madre no sean iguales
  const regex = new RegExp(`^${currentPath}(/|$)`);

  return regex.test(pathname);
};

export { hasRoute };
